export default __webpack_public_path__ + "static/media/homepage-hero-section.23fc3692.png";